var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bizcomp-combo-fund bizcomp ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),_c('fund-risk-filter',{attrs:{"qryall":_vm.qryallfund},on:{"qry-change":_vm.qryChange}}),_c('combo-list',{ref:"comboList",on:{"combo-list":_vm.getData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }